import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { BridgeProfitAndDscrCalculatorStore } from '../stores';

export const useBridgeProfitAndDscrCalculatorStore = () => useContext<{
  bridgeProfitAndDscrCalculatorStore: BridgeProfitAndDscrCalculatorStore
}>(StoreContext);
